import type { BuiltInCheck, ValueKind } from '../field-types/card';
import { FILE_MESSAGES } from 'framework/files';

export interface SaidBound {
  said: string;
  one: boolean;
}

type Words = { [E in 'min' | 'max']: (bound: SaidBound) => string };

const PLAIN_WORDS: Words = {
  min: ({ said }) => `At least ${said}`,
  max: ({ said }) => `At most ${said}`,
};

const counted = ({ said, one }: SaidBound, thing: string): string => {
  return `${said} ${one ? thing : `${thing}s`}`;
};

export const USER_PLACEHOLDERS = {
  required: {
    field: 'This field is required',
    rows: 'Add at least one row',
  },
  range: {
    today: 'today',
    deletedField: 'a deleted field',
    byKind: {
      text: {
        min: bound => `At least ${counted(bound, 'character')}`,
        max: bound => `At most ${counted(bound, 'character')}`,
      },
      options: {
        min: ({ said }) => `Select at least ${said}`,
        max: ({ said }) => `Select at most ${said}`,
      },
      files: {
        min: bound => `Attach at least ${counted(bound, 'file')}`,
        max: bound => `At most ${counted(bound, 'file')}`,
      },
      rows: {
        min: bound => `Add at least ${counted(bound, 'row')}`,
        max: bound => `At most ${counted(bound, 'row')}`,
      },
      number: PLAIN_WORDS,
      date: {
        min: ({ said }) => `Not earlier than ${said}`,
        max: ({ said }) => `Not later than ${said}`,
      },
      option: PLAIN_WORDS,
      boolean: PLAIN_WORDS,
    } satisfies { [K in ValueKind]: Words },
  },
  unique: (row: number, selected: boolean) => `Already ${selected ? 'selected' : 'entered'} in row ${row}`,
  pattern: {
    invalid: 'Invalid format',
    digitsOnly: 'Only digits are allowed',
    lettersOnly: 'Only letters are allowed',
    latinLettersOnly: 'Only Latin letters are allowed',
  },
  builtIn: {
    emailFormat: 'Enter email address like name@syberry.com',
    phoneFormat: 'Enter a phone number: + 7 to 15 digits',
    number: 'Please, enter a number',
    realDate: 'Please, enter a date, like 2027-10-07',
    wholeNumber: 'Please, enter a whole number',
  } satisfies { [C in BuiltInCheck]: string },
  files: FILE_MESSAGES,
};
